const Movie = [
    {
      id: 1,
      image: "public/images/1.jpg",
      name: "Iron Man ",
      category: "Phase 1",
      price: "12₹",
      description:
        "Iron Man is a 2008 American superhero film based on the Marvel Comics character of the same name. Produced by Marvel Studios and distributed by Paramount Pictures, it is the first film in the Marvel Cinematic Universe (MCU).",
    },
  
    {
      id: 2,
      image: "images/2.jpeg",
      name: "Incredible Hulk",
      category: "Phase 1",
      price: "20₹",
      description:
        "Dr Bruce Banner subjects himself to high levels of gamma radiation which triggers his transformation into a huge green creature, the Hulk, whenever he experiences negative emotions such as anger.",
    },
    {
      id: 3,
      image: "images/3.jpeg",
      name: "Iron Man 2",
      category: "Phase 1",
      price: "10₹",
      description:
        "Tony Stark is under pressure from various sources, including the government, to share his technology with the world. He must find a way to fight them while also tackling his other enemies.",
    },
    {
      id: 4,
      image: "../images/4.jpg",
      name: "Thor",
      category: "Phase 1",
      price: "50₹",
      description:
        "Thor is a 2011 American superhero film based on the Marvel Comics character of the same name. Produced by Marvel Studios and distributed by Paramount Pictures, it is the fourth film in the Marvel Cinematic Universe (MCU)",
    },
  
    {
      id: 5,
      image: "../images/5.jpg",
      name: "Captain America: The First Avenger",
      category: "Phase 1",
      price: "80₹",
      description:
        "During World War II, Steve Rogers decides to volunteer in an experiment that transforms his weak body. He must now battle a secret Nazi organisation headed by Johann Schmidt to defend his nation",
    },
    {
      id: 6,
      image: "../images/6.webp",
      name: "The Avengers",
      category: "Phase 1",
      price: "180₹",
      description:
        "Nick Fury is compelled to launch the Avengers Initiative when Loki poses a threat to planet Earth. His squad of superheroes put their minds together to accomplish the task.",
    },
    {
      id: 7,
      image: "../images/7.jpg",
      name: "Iron Man 3",
      category: "Phase 2",
      price: "60₹",
      description:
        "Tony Stark encounters a formidable foe called the Mandarin. After failing to defeat his enemy, Tony embarks on a journey of self-discovery as he fights against the powerful Mandarin.",
    },
    {
      id: 8,
      image: "../images/8.jpg",
      name: "Thor:The Dark World",
      category: "Phase 2",
      price: "60₹",
      description:
        "Thor sets out on a journey to defeat Malekith, the leader of the Dark Elves when he returns to Asgard to retrieve a dangerous weapon and fulfill his desire of destroying the Nine RealmsS",
    },
    {
      id: 9,
      image: "../images/9.jpg",
      name: "Captain America:The winter soldier",
      category: "Phase 2",
      price: "10₹",
      description:
        "As Steve Rogers adapts to the complexities of a contemporary world, he joins Natasha Romanoff and Sam Wilson in his mission to uncover the secret behind a deadly, mysterious assassin.",
    },
    {
      id: 10,
      image: "../images/10.jpg",
      name: "Gaurdians of the Galaxy",
      category: "Phase 2",
      price: "10₹",
      description:
        "Peter escapes from the planet Morag with a valuable orb that Ronan the Accuser wants. He eventually forms a group with unwilling heroes to stop Ronan.",
    },
    {
      id: 11,
      image: "../images/11.jpg",
      name: "Avengers age of Ultron",
      category: "Phase 2",
      price: "10₹",
      description:
        "Tony Stark builds an artificial intelligence system named Ultron with the help of Bruce Banner. When the sentient Ultron makes plans to wipe out the human race, the Avengers set out to stop him.",
    },
    {
      id: 12,
      image: "../images/12.jpg",
      name: "Ant Man",
      category: "Phase 2",
      price: "10₹",
      description:
        "Ant-Man is a 2015 American superhero film based on the Marvel Comics characters of the same name: Scott Lang and Hank Pym. Produced by Marvel Studios and distributed by Walt Disney Studios Motion Pictures, it is the 12th film in the Marvel Cinematic Universe (MCU).",
    },
    {
      id: 13,
      image: "../images/13.webp",
      name: "Captain America:Civil War",
      category: "Phase 3",
      price: "10₹",
      description:
        "Friction arises between the Avengers when one group supports the government's decision to implement a law to control their powers while the other opposes it.",
    },
    {
      id: 14,
      image: "../images/14.jpg",
      name: "Doctor Strange",
      category: "Phase 3",
      price: "10₹",
      description:
        "Dr Stephen Strange casts a forbidden spell that opens a portal to the multiverse. However, a threat emerges that may be too big for his team to handle.",
    },
    {
      id: 15,
      image: "../images/15.jpg",
      name: "Gaurdians of Galaxy vol2",
      category: "Phase 3",
      price: "10₹",
      description:
        "After a successful mission, Quill and his team of galactic defenders meet Ego, a man claiming to be Quill's father. However, they soon learn some disturbing truths about Ego.",
    },
    {
      id: 16,
      image: "../images/16.jpg",
      name: "SpiderMan Homecoming",
      category: "Phase 3",
      price: "10₹",
      description:
        "Thrilled by his experience with the Avengers, young Peter Parker returns home to live with his Aunt May. Under the watchful eye of mentor Tony Stark, Parker starts to embrace his newfound identity as Spider-Man. He also tries to return to his normal daily routine -- distracted by thoughts of proving himself.",
    },
    {
      id: 17,
      image: "../images/17.jpeg",
      name: "Thor:Ragnorok",
      category: "Phase 3",
      price: "10₹",
      description:
        "Deprived of his mighty hammer Mjolnir, Thor must escape the other side of the universe to save his home, Asgard, from Hela, the goddess of death.",
    },
    {
      id: 18,
      image: "../images/18.jpg",
      name: "Black Panther",
      category: "Phase 3",
      price: "10₹",
      description:
        "After his father's death, T'Challa returns home to Wakanda to inherit his throne. However, a powerful enemy related to his family threatens to attack his nation.",
    },
    {
      id: 19,
      image: "../images/19.jpg",
      name: "Avengers Infinty War",
      category: "Phase 3",
      price: "10₹",
      description:
        "The Avengers must stop Thanos, an intergalactic warlord, from getting his hands on all the infinity stones. However, Thanos is prepared to go to any lengths to carry out his insane plan.",
    },
    {
      id: 20,
      image: "../images/20.jpg",
      name: "Ant-Man and the Wasp",
      category: "Phase 3",
      price: "10₹",
      description:
        "Despite being under house arrest, Scott Lang, along with the Wasp, sets out to help Dr Hank Pym to enter the quantum realm as they face new enemies along the way.   ",
    },
    {
      id: 21,
      image: "../images/21.jpg",
      name: "Captain Marvel",
      category: "Phase 3",
      price: "10₹",
      description:
        "Captain Marvel is a 2019 American superhero film based on Marvel Comics featuring the character Carol Danvers / Captain Marvel. Produced by Marvel Studios and distributed by Walt Disney Studios Motion Pictures, it is the 21st film in the Marvel Cinematic Universe (MCU).",
    },
    {
      id: 22,
      image: "../images/22.webp",
      name: "Avengers: Endgame",
      category: "Phase 3",
      price: "10₹",
      description:
        "After Thanos, an intergalactic warlord, disintegrates half of the universe, the Avengers must reunite and assemble again to reinvigorate their trounced allies and restore balance.",
    },
    {
      id: 23,
      image: "../images/23.webp",
      name: "Spider-Man:Far From Home",
      category: "Phase 3",
      price: "10₹",
      description:
        "Peter Parker, the beloved superhero Spider-Man, faces four destructive elemental monsters while on holiday in Europe. Soon, he receives help from Mysterio, a fellow hero with mysterious origins.",
    },
    {
      id: 24,
      image: "../images/24.jpg",
      name: "WandaVision",
      category: "Phase 4",
      price: "10₹",
      description:
        "Living idealized suburban lives, super-powered beings Wanda and Vision begin to suspect that everything is not as it seems.",
    },
    {
      id: 25,
      image: "../images/25.webp",
      name: "The Falcon & Winter Soldier",
      category: "Phase 4",
      price: "10₹",
      description:
        "Falcon and the Winter Soldier are a mismatched duo who team up for a global adventure that will test their survival skills -- as well as their patience.",
    },
    {
      id: 26,
      image: "../images/26.jpg",
      name: "Loki",
      category: "Phase 4",
      price: "10₹",
      description:
        "Loki, the God of Mischief, steps out of his brother's shadow to embark on an adventure that takes place after the events of Avengers: Endgame.",
    },
    {
      id: 27,
      image: "../images/27.jpeg",
      name: "Black Widow",
      category: "Phase 4",
      price: "10₹",
      description:
        "Natasha Romanoff, a former KGB spy, is shocked to find out that her ex handler, General Dreykov, is still alive. While evading capture by Taskmaster, she is forced to confront her dark past.",
    },
    {
      id: 28,
      image: "../images/28.webp",
      name: "What If?",
      category: "Phase 4",
      price: "10₹",
      description:
        "Reimagining noteworthy events in the Marvel Cinematic Universe and creating a multiverse of infinite possibilities.",
    },
    {
      id: 29,
      image: "../images/29.jpg",
      name: "ShangChi",
      category: "Phase 4",
      price: "10₹",
      description:
        "Martial-arts master Shang-Chi confronts the past he thought he left behind when he's drawn into the web of the mysterious Ten Rings organization.",
    },
    {
      id: 30,
      image: "../images/30.jpg",
      name: "Hawkeye",
      category: "Phase 4",
      price: "10₹",
      description:
        "Clint Barton and Kate Bishop shoot a few arrows and try to avoid becoming the target themselves.",
    },
    {
      id: 31,
      image: "../images/31.jpeg",
      name: "Eternals",
      category: "Phase 4",
      price: "10₹",
      description:
        "The Eternals, a race of immortal beings with superhuman powers who have secretly lived on Earth for thousands of years, reunite to battle the evil Deviants.",
    },
    {
      id: 32,
      image: "../images/32.webp",
      name: "Spider:No Way-Home",
      category: "Phase 4",
      price: "10₹",
      description:
        "Peter Parker seeks Doctor Strange's help to make people forget about Spiderman's identity. However, when the spell he casts gets corrupted, several unwanted guests enter their universe.",
    },
    {
      id: 33,
      image: "../images/33.webp",
      name: "Moon Knight",
      category: "Phase 4",
      price: "10₹",
      description:
        "Steven Grant and mercenary Marc Spector investigate the mysteries of the Egyptian gods from inside the same body.",
    },
    {
      id: 34,
      image: "../images/34.webp",
      name: "Doctor Strange in the Multiverse of Madness",
      category: "Phase 4",
      price: "10₹",
      description:
        "Dr Stephen Strange casts a forbidden spell that opens a portal to the multiverse. However, a threat emerges that may be too big for his team to handle.",
    },
    {
      id: 35,
      image: "../images/35.jpg",
      name: "Thor:Love and Thunder",
      category: "Phase 4",
      price: "10₹",
      description: "Thor embarks on a journey unlike anything he's ever faced -- a quest for inner peace. However, his retirement gets interrupted by Gorr the God Butcher, a galactic killer who seeks the extinction of the gods. To combat the threat, ",
    },
    {
      id: 36,
      image: "../images/35.jpg",
      name: "Black Panther: Wakanda Forever",
      category: "Phase 4",
      price: "10₹",
      date:"11 November 2022",
      description: "Black Panther: Wakanda Forever is an upcoming American superhero film based on the Marvel Comics character Black Panther. Produced by Marvel Studios and distributed by Walt Disney Studios Motion Pictures, it is intended to be the sequel to Black Panther and the 30th film in the Marvel Cinematic ",
    },
    {
      id: 37,
      image: "../images/35.jpg",
      name: "Ant-Man And The Wasp: Quantumania",
      category: "Phase 5",
      price: "10₹",
      date:"February 17, 2023",
      description: "Ant-Man And The Wasp: Quantumania is all set to be released in February 2023, the first Marvel Studios release of the year.and the first film of Phase 5.",
    },
    {
      id: 38,
      image: "../images/35.jpg",
      name: "Guardians Of The Galaxy Vol. 3",
      category: "Phase 5",
      price: "10₹",
      date:"May 5, 2023",
      description: "Guardians of the Galaxy Vol. 3 is an upcoming American superhero film based on the Marvel Comics superhero team Guardians of the Galaxy, produced by Marvel Studios and distributed by Walt Disney",
    },
    {
      id: 39,
      image: "../images/35.jpg",
      name: "The Marvels",
      category: "Phase 5",
      price: "10₹",
      date:"July 28, 2023",
      description: "Following some shuffling in the schedule, it has been confirmed that The Marvels will be the Marvel Cinematic Universe release of 2023, and at the helm of the project will be Nia DaCosta, fresh off her excellent Candyman sequel. Story details have not been confirmed, but Teyonah Parris will return as Monica Rambeau following her stint on the Disney+ series WandaVision, and it's been confirmed that Iman Vellani, star of Disney+'s Ms. Marvel upcoming series, will have a supporting role in the blockbuster as well.",
    },
    {
      id: 40,
      image: "../images/35.jpg",
      name: "Blade",
      category: "Phase 5",
      price: "10₹",
      date:"November 3, 2023",
      description: "Blade is a fictional character appearing in American comic books published by Marvel Comics. Created by writer Marv Wolfman and penciller Gene Colan, his first appearance was in the comic book The Tomb of Dracula #10 as a supporting character, but later went on to star in his own storylines.",
    },
    {
      id: 41,
      image: "../images/35.jpg",
      name: "Captain America: New World Order",
      category: "Phase 5",
      price: "10₹",
      date:"May 3, 2024",
      description: "Anthony Mackie's Captain America movie gets New World Order title and 2024 release. The next Cap movie is coming in Marvel's Phase Five slate.4",
    },
    {
      id: 42,
      image: "../images/35.jpg",
      name: "Thunderbolts",
      category: "Phase 5",
      price: "10₹",
      date:"July 26, 2024",
      description: "The Thunderbolts are a fictional antihero team appearing in American comic books published by Marvel Comics. The team consists mostly of reformed supervillains",
    },
    {
      id: 43,
      image: "../images/35.jpg",
      name: "Fantastic Four",
      category: "Phase 6",
      price: "10₹",
      date:"November 8, 2024",
      description: "Fantastic Four (styled as FANT4STIC) is a 2015 American superhero film based on the Marvel Comics superhero team of the same name, and is a reboot of the Fantastic Four film franchise.",
    },
    {
      id: 44,
      image: "../images/35.jpg",
      name: "Avengers: The Kang Dynasty",
      category: "Phase 6",
      price: "10₹",
      date:"May 2, 2025",
      description: "Kang Dynasty, sometimes called Kang War, is a 16 part comic book storyline which ran through Avengers #41-55 and Avengers Annual 2001 between June, 2001 and August, 2002. It was written by Kurt Busiek and illustrated by a number of artists including Alan Davis, Kieron Dwyer, Ivan Reis and Manuel",
    },
    {
      id: 45,
      image: "../images/35.jpg",
      name: "Avengers: Secret Wars",
      category: "Phase 6",
      price: "10₹",
      date:"November 7, 2025",
      description:"Marvel Super Heroes Secret Wars, commonly known as Secret Wars for short, is a twelve-issue American comic book crossover limited series published from May 1984 to April 1985 by Marvel Comics. The series was written by Jim Shooter, with art by Mike Zeck and Bob Layton",
    },
  ];
  
  export default Movie;